<script>
import { mapGetters, mapActions } from 'vuex'

import { TheMask } from 'vue-the-mask'
import Multiselect from 'vue-multiselect'

import OrganizationTypeList from '@/components/components/Inputs/OrganizationTypeList'
import SelectPool from '@/components/catalog/SelectPool.vue'
import Fish from '@/components/components/Inputs/fish'

import { apiSecond } from '@/boot/axios'
import { convertObjectToFormData } from '@/formData'
import { alertNcaNotRunning } from '@/helpers'

export default {
	components: {
		TheMask,
		OrganizationTypeList,
		Multiselect,
		SelectPool,
		Fish,
	},
	data() {
		return {
			applications: null,
			regionModel: [],
			catch_type_ids: [],
			zpm: {
				activity_type: '',
				start_date: '',
				end_date: '',
				fishes: [{ fish_id: null, design_capacity: '' }],
			},
			signing: false,
			gbdUl: null,
			gbdUlLoading: false,
			errorMessage: {
				status: null,
				messages: null,
				text: null,
			},
			message: {
				status: null,
				text: null,
				texts: null,
			},
		}
	},
	computed: {
		...mapGetters(['_getRegionList']),
		isAquaKind() {
			return ['aquaculture', 'feed_producer'].includes(this.applications?.subject_kind)
		},
		isAquaculture() {
			return this.applications?.subject_kind === 'aquaculture'
		},
		isLegalEntity() {
			return /^\d{4}[456]\d{7}$/.test(String(this.applications?.iin_bin || '').trim())
		},
		needsZpm() {
			return this.isAquaculture && !this.applications?.existing_zpm
		},
		zpmFilled() {
			return (
				!!this.zpm.start_date &&
				!!this.zpm.end_date &&
				this.zpm.end_date >= this.zpm.start_date &&
				this.zpm.fishes.length > 0 &&
				this.zpm.fishes.every((fish) => fish.fish_id && Number(fish.design_capacity) > 0)
			)
		},
	},
	methods: {
		...mapActions(['_fetchRegionList']),
		addZpmFish() {
			this.zpm.fishes.push({ fish_id: null, design_capacity: '' })
		},
		removeZpmFish(index) {
			this.zpm.fishes.splice(index, 1)
		},
		approve() {
			if (!this.isAquaKind) return this.activeElement(this.applications.id)
			if (this.needsZpm && !this.zpmFilled) {
				this.$toast.error(this.$t('subject_kind.zpm_required'))
				return
			}
			if (this.$configFile.active) return this.activeElement(this.applications.id, this.$configFile.xml)
			const websocket = new WebSocket('wss://127.0.0.1:13579/')
			this.signing = true
			websocket.onopen = () => {
				websocket.send(
					JSON.stringify({
						module: 'kz.gov.pki.knca.commonUtils',
						method: 'signXml',
						args: [
							'PKCS12',
							'SIGNATURE',
							`<register><register_id>${this.applications.id}</register_id></register>`,
							'',
							'',
						],
					}),
				)
			}
			websocket.onclose = (event) => {
				this.signing = false
				if (!event.wasClean) alertNcaNotRunning()
			}
			websocket.onmessage = (event) => {
				const response = JSON.parse(event.data)
				if (response.responseObject) {
					websocket.close()
					this.activeElement(this.applications.id, response.responseObject)
				}
			}
		},
		activeElement(id, xml = null) {
			const formData = xml
				? convertObjectToFormData(this.needsZpm ? { xml, zpm: this.zpm } : { xml })
				: new FormData()
			if (!xml) formData.append('role_id', 3)
			apiSecond
				.post('v1/user/register/' + id + '/accept', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then((response) => {
					if (response.status == 200) {
						this.message.status = 200
						this.message.text = response.data.message
						this.applications.status = null
						this.$toast.success(this.$t('toast.approved'))
						this.$router.push({ path: '/' + this.$i18n.locale + '/account/request_registration' })
					}
				})
				.catch((error) => {
					if (error.response == 'undefined') {
						this.applications.status = null
					}
					if (error.response && error?.response?.status == 200) {
						this.message.status = 200
						this.message.text = error?.response?.data?.message
						this.$toast.success(this.$t('toast.approved'))
						this.$router.push({ path: '/' + this.$i18n.locale + '/account/request_registration' })
					}
					if (error.response && error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
					}
					if (error.response && error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
					if (error?.response?.status != 200) {
						this.$toast.apiError(error, this.$t('toast.error'))
					}
				})
				.finally(() => {
					this.signing = false
				})
		},
		blockElement(evt) {
			const formData = new FormData(evt.target)
			apiSecond
				.post('v1/user/register/' + this.applications.id + '/deny', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then((response) => {
					if (response.status == 200) {
						this.$modal.hide('modal_delete')
						this.$toast.success(this.$t('toast.rejected'))
						this.$router.push({ path: '/' + this.$i18n.locale + '/account/request_registration' })
					}
				})
				.catch((error) => {
					this.$toast.apiError(error, this.$t('toast.error'))
				})
		},
		gbdStatusName(organization) {
			return this.$i18n.locale === 'kz' && organization.status_name_kz ? organization.status_name_kz : organization.status_name_ru
		},
		async checkGbdUl() {
			this.gbdUlLoading = true
			try {
				const { data } = await apiSecond.get(`v1/user/register/${this.applications.id}/gbd-ul`)
				this.gbdUl = data
			} catch (error) {
				this.$toast.apiError(error, this.$t('toast.error'))
			} finally {
				this.gbdUlLoading = false
			}
		},
		apiGetUser() {
			apiSecond
				.get('v1/user/register/' + this.$route.params.id)
				.then((response) => {
					if (response.data) {
						this.applications = response.data
						if (this.isLegalEntity && !this.gbdUl) this.checkGbdUl()
						this.catch_type_ids = response.data.catch_type_ids
						this.regionModel = this._getRegionList.find((region) => {
							return region.id == response.data.region_id
						})
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.errorMessage.status = 500
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					}
					if (error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
					if (error?.response?.status == 404) {
						this.errorMessage.status = 404
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 403) {
						this.errorMessage.status = 403
						this.errorMessage.text = error?.response?.data?.message
					}
				})
		},
		apiGetUserList() {
			apiSecond
				.get('v1/user/role/list')
				.then((response) => {
					if (response.data) {
						this.roleList = response.data
					}
				})
				.catch((error) => {
					if (error?.response?.status == 500) {
						this.errorMessage.status = 500
						this.errorMessage.text = this.$t('system_message.500')
					}
					if (error?.response?.status == 401) {
						this.errorMessage.status = 401
						this.errorMessage.text = error.response.data.error_message
						this.$router.push('/' + this.$i18n.locale + '/login')
					}
					if (error?.response?.status == 422) {
						this.errorMessage.status = 422
						this.errorMessage.text = error.response.data.error_message
					}
				})
		},
	},
	async beforeMount() {
		await this._fetchRegionList()
		this.apiGetUser()
		this.apiGetUserList()
	},
	beforeCreate() {
		if (!localStorage.token) {
			this.$router.push('/ru/login')
		}
	},
}
</script>

<template>
	<div class="wrap__content" v-bind:class="{ 'wrap__content--preloader': !applications }">
		<v-preloader v-if="!applications" :message="errorMessage"></v-preloader>

		<div class="container" v-if="applications">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['UserManagementMain', 'RequestRegistration']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__page--back">
										<a @click="$router.go(-1)">
											<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13.125 5.25l-5.25 5.25 5.25 5.25" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</a>
									</div>
									<div class="content__title--element">
										<div class="content__title--text">
											{{ $t('sidebar.request_registration') }}
										</div>
										<div class="content__title--subtext">
											{{ $t(`subject_kind.${applications.subject_kind || 'fishery'}`) }} ({{
												applications.first_name
											}}
											{{ applications.last_name }} {{ applications.middle_name }})
										</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div v-if="_getRegionList" class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.regions') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div
													class="form__line--input"
													:class="[
														errorMessage.messages && errorMessage.messages.region_id
															? 'input--error'
															: '',
													]"
												>
													<multiselect
														class="select__status"
														v-model="regionModel"
														:options="_getRegionList"
														:placeholder="$t('labels.select_region')"
														:multiple="true"
														:close-on-select="false"
														:clear-on-select="false"
														:disabled="true"
														:preserve-search="true"
														track-by="id"
														label="name"
														required=""
													>
														<template slot="singleLabel" slot-scope="{ option }">{{
															option.name
														}}</template>
														<template slot="option" slot-scope="{ option }">
															<div class="select__check">
																<div class="select__check--name">
																	{{ option.name }}
																</div>
															</div>
														</template>
														<template slot="noResult">{{ $t('components.not_found') }}</template>
													</multiselect>
												</div>
												<div
													class="input-required"
													v-if="errorMessage.messages && errorMessage.messages.region_id"
												>
													<p
														v-for="(massage, massageInd) in errorMessage.messages.region_id"
														:key="massageInd"
													>
														{{ massage }}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.user_name') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<input
														type="text"
														class="input-linck"
														:value="applications.first_name"
														disabled
														:placeholder="$t('headers.user_name')"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.user_surname') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<input
														type="text"
														class="input-linck"
														:value="applications.last_name"
														disabled
														:placeholder="$t('headers.user_surname')"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.user_patronymic') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<input
														type="text"
														class="input-linck"
														:value="applications.middle_name"
														disabled
														:placeholder="$t('headers.user_patronymic')"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.user_role') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div
													class="form__line--input"
													:class="[
														errorMessage.messages && errorMessage.messages.job
															? 'input--error'
															: '',
													]"
												>
													<input
														type="text"
														class="input-linck"
														name="job"
														disabled
														v-model="applications.job"
														:placeholder="$t('headers.user_role')"
													/>
												</div>
												<div
													class="input-required"
													v-if="errorMessage.messages && errorMessage.messages.job"
												>
													<p
														v-for="(massage, massageInd) in errorMessage.messages.job"
														:key="massageInd"
													>
														{{ massage }}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.name_company') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<input
														type="text"
														class="input-linck"
														:value="applications.name_company"
														disabled
														:placeholder="$t('headers.name_company')"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('handbooks.Бассейн') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<SelectPool
														:withTitle="false"
														:value="applications.pools"
														:multiple="true"
														:disabled="true"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div v-if="!isAquaKind" class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('handbooks.Тип организаций') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<div
														v-if="applications.catch_types && applications.catch_types.length"
														class="input-body multiselect__tags"
														style="min-height: 38px; display: flex; flex-wrap: wrap; gap: 4px"
													>
														<span
															v-for="ct in applications.catch_types"
															:key="ct.id"
															class="multiselect__tag"
														>
															{{ $i18n.locale === 'kz' ? ct.title_kaz || ct.title : ct.title }}
														</span>
													</div>
													<div v-else>
														<span class="text-muted">{{ $t('placeholder.choose') }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.iin') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<input
														type="text"
														class="input-linck"
														:value="applications.iin_bin"
														disabled
														:placeholder="$t('headers.iin')"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div v-if="isLegalEntity" class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('gbd_ul.title') }}</div>
									</div>
									<div class="form__line--right">
										<a v-if="!gbdUl" class="btn--link" :class="{ disabled: gbdUlLoading }" @click.prevent="!gbdUlLoading && checkGbdUl()">
											{{ gbdUlLoading ? $t('gbd_ul.loading') : $t('gbd_ul.check') }}
										</a>
										<div v-else-if="gbdUl.status === 'found'">
											<div>{{ gbdUl.organization.name_ru }}</div>
											<div>
												{{ $t('gbd_ul.registration_date') }}: {{ gbdUl.organization.registration_date || '—' }};
												{{ $t('gbd_ul.status') }}:
												<strong :class="gbdUl.organization.is_active ? 'gbd-ul-ok' : 'gbd-ul-bad'">
													{{ gbdStatusName(gbdUl.organization) || gbdUl.organization.status_code }}
												</strong>
											</div>
										</div>
										<div v-else class="gbd-ul-bad">
											{{ $t(`gbd_ul.${gbdUl.status}`) }}
											<span v-if="gbdUl.message">({{ gbdUl.message }})</span>
											<a v-if="gbdUl.status === 'unavailable'" class="btn--link" @click.prevent="gbdUl = null">{{ $t('gbd_ul.retry') }}</a>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.email') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<input
														type="text"
														class="input-linck"
														:value="applications.email"
														disabled
														:placeholder="$t('headers.email')"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('site.registration.phone') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row">
											<div class="col-xl-5">
												<div class="form__line--input">
													<div
														class="form__block--input"
														:class="[
															errorMessage.messages && errorMessage.messages.phone
																? 'input--error'
																: '',
														]"
													>
														<TheMask
															:value="applications.phone"
															:placeholder="'+7 (_ _ _)  _ _ _  _ _  _ _'"
															:mask="['+7 (###) ### ## ##']"
															:masked="true"
															:disabled="true"
															name="phone"
															type="tel"
															class="input-linck"
														/>
													</div>
													<div
														class="input-required"
														v-if="errorMessage.messages && errorMessage.messages.phone"
													>
														<p
															v-for="(massage, massageInd) in errorMessage.messages.phone"
															:key="massageInd"
														>
															{{ massage }}
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('headers.file') }}</div>
									</div>
									<div class="form__line--right">
										<a
											v-for="document in applications.documents"
											:key="document.id"
											:style="{
												display: 'block',
												maxWidth: '120px',
												overflow: 'hidden',
												marginBottom: '3px',
												cursor: 'pointer',
												textOverflow: 'ellipsis',
											}"
											:href="'https://api.efish.kz/' + document.document"
											target="_blank"
										>
											{{ document.document.split('/').pop() }}
										</a>
									</div>
								</div>

								<div v-if="isAquaculture && applications.existing_zpm" class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('subject_kind.zpm_title') }}</div>
									</div>
									<div class="form__line--right">
										{{ $t('subject_kind.zpm_exists') }}: {{ applications.existing_zpm.zpm_nikad }}<span v-if="applications.existing_zpm.archived"> ({{ $t('subject_kind.zpm_archived') }})</span>
									</div>
								</div>

								<div v-if="needsZpm && applications.status == 'new'" class="form__line">
									<div class="form__line--left">
										<div class="form__line--title">{{ $t('subject_kind.zpm_title') }}</div>
									</div>
									<div class="form__line--right">
										<div class="row mb-3">
											<div class="col-xl-12 mb-2">
												<input
													v-model="zpm.activity_type"
													class="input-linck"
													type="text"
													maxlength="255"
													:placeholder="$t('subject_kind.activity_type')"
												/>
											</div>
											<div class="col-xl-6">
												<div class="form__line--title">{{ $t('subject_kind.start_date') }}</div>
												<input v-model="zpm.start_date" class="input-linck" type="date" />
											</div>
											<div class="col-xl-6">
												<div class="form__line--title">{{ $t('subject_kind.end_date') }}</div>
												<input v-model="zpm.end_date" class="input-linck" type="date" :min="zpm.start_date" />
											</div>
										</div>
										<div v-for="(fish, fishIndex) in zpm.fishes" :key="fishIndex" class="row mb-2 items-end">
											<div class="col-xl-6">
												<fish
													:modelValue="fish.fish_id"
													:placeholder="$t('placeholder.choose')"
													@update:modelValue="fish.fish_id = $event"
												></fish>
											</div>
											<div class="col-xl-4">
												<input
													v-model="fish.design_capacity"
													class="input-linck"
													type="number"
													min="0"
													step="0.01"
													:placeholder="$t('subject_kind.design_capacity')"
												/>
											</div>
											<div class="col-xl-2">
												<a v-if="zpm.fishes.length > 1" class="tb__table--link" @click="removeZpmFish(fishIndex)">
													{{ $t('button.delete') }}
												</a>
											</div>
										</div>
										<a class="btn--link btn--link--plus" @click="addZpmFish">
											{{ $t('subject_kind.add_fish') }} <img src="@/assets/img/icon-plus.svg" />
										</a>
									</div>
								</div>

								<div class="form__line form__line--comment" v-if="applications.comment">
									<div class="form__line--left">
										<div class="form__line--title">Причина отказа</div>
									</div>
									<div class="form__line--right">
										<div class="col-xl-12">
											{{ applications.comment }}
										</div>
									</div>
								</div>

								<div class="form__line">
									<div class="form__line--right">
										<div class="input__row">
											<button
												class="input-btn form__line--btn"
												v-if="applications.status == 'new'"
												:disabled="signing"
												@click="approve"
											>
												{{ isAquaKind ? $t('subject_kind.approve_eds') : $t('labels.approve') }}
												<img src="@/assets/img/icon-success-w.svg" />
											</button>
											<button
												class="input-btn form__line-error form__line--btn"
												v-if="applications.status == 'new'"
												@click="$modal.show('modal_delete')"
											>
												{{ $t('subject_kind.reject') }}<img src="@/assets/img/icon-close-w.svg" />
											</button>
										</div>
									</div>
								</div>

								<div
									class="form__block--line form__messages"
									v-if="message.text"
									:class="{
										'form__messages--error': message.status != 200,
										'form__messages--success': message.status == 200,
									}"
								>
									<label class="form__block--input">
										<span class="form__block--title">
											{{ message.text }}
										</span>
									</label>
								</div>

								<modal
									class="modal__block modal__block--middle modal__block--delete"
									name="modal_delete"
									:width="550"
									:min-width="550"
									height="auto"
								>
									<div class="modal__block--wrapper">
										<div class="modal__block--close" @click="$modal.hide('modal_delete')">
											<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22.5 7.5l-15 15M7.5 7.5l15 15" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
										</div>
										<div class="modal__wrapper">
											<div class="modal__header">
												<div class="modal__title">
													{{
														$t('messages.are_you_sure_to_reject_user', [
															applications.first_name +
																' ' +
																applications.last_name +
																' ' +
																applications.middle_name,
														])
													}}<br />
												</div>
											</div>

											<form method="POST" @submit.prevent="blockElement">
												<div class="modal__content">
													<div class="modal__form">
														<div class="form__line">
															<div class="form__line--right">
																<div
																	class="form__line--input"
																	:class="[
																		errorMessage.messages && errorMessage.messages.comment
																			? 'input--error'
																			: '',
																	]"
																>
																	<textarea
																		class="input-linck"
																		required=""
																		name="comment"
																		:placeholder="$t('labels.reject_reason')"
																	></textarea>
																</div>
																<div
																	class="input-required"
																	v-if="errorMessage.messages && errorMessage.messages.comment"
																>
																	<p
																		v-for="(massage, massageInd) in errorMessage.messages.comment"
																		:key="massageInd"
																	>
																		{{ massage }}
																	</p>
																</div>
															</div>
														</div>

														<div class="block__row">
															<div class="block__row--left">
																<button class="block__item">
																	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.024 12.976l4.952-4.952m0 4.952L8.024 8.024M10.5 19.25c4.813 0 8.75-3.938 8.75-8.75 0-4.813-3.938-8.75-8.75-8.75-4.813 0-8.75 3.938-8.75 8.75 0 4.813 3.938 8.75 8.75 8.75z" stroke="#DF4242" stroke-linecap="round" stroke-linejoin="round"/></svg>
																	{{ $t('button.deactivate') }}
																</button>
															</div>
															<div class="block__row--right">
																<a
																	class="block__item block__item--blue"
																	@click="$modal.hide('modal_delete')"
																>
																	{{ $t('button.cancel') }}
																</a>
															</div>
														</div>
														<div
															class="form__block--line form__messages"
															v-if="message.status"
															:class="{
																'form__messages--error': message.status != 200,
																'form__messages--success': message.status == 200,
															}"
														>
															<label class="form__block--input">
																<span class="form__block--title">
																	{{ message.text }}
																</span>
															</label>
														</div>
													</div>
												</div>
											</form>
										</div>
									</div>
								</modal>
							</div>
							<div
								v-if="errorMessage && errorMessage.text"
								class="form__preloader--text form__block--line form__messages form__messages--error"
							>
								<label class="form__block--input">
									<span class="form__block--title">
										{{ errorMessage.text }}
									</span>
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.gbd-ul-ok {
	color: #1e8e3e;
}
.gbd-ul-bad {
	color: #c0392b;
}
</style>
